/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filtercontrast1Inputs */

const en_filtercontrast1 = /** @type {(inputs: Filtercontrast1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrast`)
};

const de_filtercontrast1 = /** @type {(inputs: Filtercontrast1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontrast`)
};

/**
* | output |
* | --- |
* | "Contrast" |
*
* @param {Filtercontrast1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const filtercontrast1 = /** @type {((inputs?: Filtercontrast1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filtercontrast1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filtercontrast1(inputs)
	return de_filtercontrast1(inputs)
});
export { filtercontrast1 as "filterContrast" }